import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteMatch } from '@app/router';
import { Box, Heading } from '@stockx/ui';
import { MenuItem } from '../../types/menu';
import ListMenuItem from './components/ListMenuItem';

type ListMenuProps = {
  title?: string;
  items: MenuItem[];
  itemHandleOnClick: (MenuItem) => void;
};

const ListMenuTitle = ({ title }) => {
  const { t } = useTranslation();

  if (!title) {
    return null;
  }

  return (
    <Heading size="xl" px={6} pt={3} pb={1} mb={0}>
      {t(title)}
    </Heading>
  );
};

const ListMenu = ({ items, title, itemHandleOnClick }: ListMenuProps) => {
  const { url: currentPath } = useRouteMatch();

  return (
    <Box>
      <ListMenuTitle title={title} />
      {items.map((item) => (
        <ListMenuItem
          key={item?.title}
          item={item}
          isActive={currentPath === item.path}
          handleOnClick={itemHandleOnClick}
        />
      ))}
    </Box>
  );
};

export default ListMenu;
